import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { firstValueFrom } from 'rxjs';
import { EnvConfig } from 'app/shared/model/env-config';

@Injectable({
  providedIn: 'root'
})
export default class AppConfigService {
  static envConfig: EnvConfig;

  private http: HttpClient;

  private aesPassword: string = 'BJCPassword@123';

  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  public loadConfig = async () => {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset-utf-8');
    const timeStamp = new Date().getTime();
    const url = `./assets/config/encrypted-config.txt?v=${timeStamp}`;
    const config = await firstValueFrom(this.http.get<string>(url, { headers, responseType: 'text' as 'json' }));
    if (config) {
      this.decryptConfig(config);
    }

    // const swPath = `${AppConfigService.envConfig.fssServicesBaseUrl}/ngsw-worker.js`;
    // navigator.serviceWorker.register(swPath)
    //   .catch((err) => console.error('SW registration failed', err));
  };

  decryptConfig(configData: string) {
    try {
      const base64decoded = atob(configData);
      const decrypted = CryptoJS.AES.decrypt(base64decoded, this.aesPassword.trim()).toString(CryptoJS.enc.Utf8);
      AppConfigService.envConfig = JSON.parse(decrypted);
    } catch (ex: any) {
      AppConfigService.envConfig = null;
    }
  }

  public getConfig() {
    return AppConfigService.envConfig;
  }
}
